import React from 'react';
import { CardProps } from './types';
import { CardButton, CardInfo, PriceTextLarge } from './components';
import { useCategoryCard } from './hooks';

import { CardWrapper, CardWrapperMini, CardCommonStyles, CardContent, CardImg } from './styles';

export const CategoryCard = ({
	categoryData,
	cardType,
	className,
	isVisible,
	onClickHandler = () => {},
}: CardProps) => {
	const {
		isSmallScreen,
		isMobile,
		isPopularCard,
		isPopularOrderCard,
		isCatalogueOrderCard,
		isOrderCard,
		preparedCategoryData,
		onClick,
		ref,
	} = useCategoryCard(categoryData, cardType, onClickHandler);
	const {
		id,
		fullPhotoUrl,
		name,
		priceText,
		description,
		fullCategoryUrl,
	} = preparedCategoryData;

	const isPriceNecessary = isPopularOrderCard || (isCatalogueOrderCard && !isSmallScreen);

	const cardButtons = (
		<div>
			{isPriceNecessary && (
				<PriceTextLarge
					unitOfMeasurement={categoryData.unitOfMeasurement}
					priceText={priceText}
				/>
			)}
			<CardButton
				unitOfMeasurement={categoryData.unitOfMeasurement}
				priceText={priceText}
				cardType={cardType}
			/>
		</div>
	);

	const children = (
		<>
			<CardImg src={fullPhotoUrl} alt="category" data-analyticsName="productPhotoLink" />
			<CardContent isFromCatalogue={isCatalogueOrderCard}>
				<CardInfo
					name={name}
					description={description}
					isOrderCard={isOrderCard}
					isPopularCard={isPopularCard}
					isSmallScreen={isSmallScreen}
				/>
				{cardButtons}
			</CardContent>
		</>
	);

	return isCatalogueOrderCard && isMobile ? (
		<CardWrapperMini
			ref={ref}
			data-qa="category-card-wrapper--small"
			data-categoryId={id}
			className={`category-card ${CardCommonStyles} ${className}`}
			onClick={onClick}
			isVisible={isVisible}
			href={fullCategoryUrl}
		>
			{children}
		</CardWrapperMini>
	) : (
		<CardWrapper
			ref={ref}
			data-qa="category-card-wrapper--large"
			data-categoryId={id}
			className={`category-card ${CardCommonStyles} ${className}`}
			onClick={onClick}
			isVisible={isVisible}
			isPopular={isPopularCard}
			href={fullCategoryUrl}
		>
			{children}
		</CardWrapper>
	);
};

CategoryCard.defaultProps = {
	className: '',
	isVisible: true,
};
